module.exports = __webpack_public_path__ + "f47cf7fcc71c115de8bd375e77c7ed71.svg";